/**
 * Order Online Code
 *
 * Each unique page (or template) has its own page script.  These
 * scripts are loaded into the template, along with the main.js
 * script, and any vendor scripts needed for the site.  The
 * individual page scripts add a 'page' object into the main
 * Otto namespace, and the main.js file then init()'s this
 * page object to execute whatever page-specific code needs
 * to be run.
 */

var Otto = Otto || {};
Otto.page = (function(my, $) {
    // Create object for storing our methods for public consumption
    // (this sets up our external API for this module)
    var exports = {};

    function wireEvents() {
        $('.faq__icon, .faq__question').click(function(evt){
            evt.preventDefault();
            closeOthers(evt.target);
            toggleIt(evt.target);
        });
    }

    function closeOthers(clickedEl) {
        var item = $(clickedEl).closest('.faq__item');
        $('.faq__item').each(function(index, el) {
            var $el = $(el);
            if (($el[0] != $(item)[0]) && $el.hasClass('faq__item--is-active')) {
                $el.removeClass('faq__item--is-active');
                $el.find('.faq__answer').slideUp();
            }
        });
    }

    function toggleIt(clickedEl) {
        var item = $(clickedEl).closest('.faq__item');
        $(item).toggleClass('faq__item--is-active');
        if ($(item).hasClass('faq__item--is-active')) {
            $(item).find('.faq__answer').slideDown();
        } else {
            $(item).find('.faq__answer').slideUp();
        }
    }

    exports.init = function() {
        $('.faq').find('.faq__answer').hide();

        wireEvents();
    };

    return exports;

})(Otto, jQuery);


